import {Link} from 'react-router'
import styles from './NavLoggedIn.css'
import {logout} from 'actions'
import _ from 'lodash'
import {shouldShowEmployeeManagement, shouldShowSalesTypeLibrary, shouldShowPromoLibrary} from 'utils/ftue'

class NavLoggedIn extends React.Component {
  render () {
    let {subMenuOf} = this.props
    return (
      <div className={`navbar-collapse collapse header-login ${styles.wrapper}`} id='NavLoggedIn'>
        <ul className='nav navbar-nav nav-outlet-dekstop-dropdown mk-navbar-nav navbar-right pull-right visible-md visible-lg'>
          <li className='dropdown'>
            <Link to='#' className='dropdown-toggle' data-toggle='dropdown' role='button'>
              <i className='glyphicon glyphicon-user' />
              <span className='fa fa-angle-down' />
            </Link>
            <ul className='dropdown-menu mk-short-profile-dropdown info-width' role='menu'>
              <li className='mk-short-profile'>
                <div className='avatar'>
                  <img src={!this.props.user.gravatar ? require('assets/images/account-profile-default.jpg') : this.props.user.gravatar} alt='account profile default' />
                </div>
                <div className='mk-business-info'>
                  <div className='business-name gt'>{this.props.user.first_name} {this.props.user.last_name}</div>
                  <div className='business-email'>{this.props.user.email}</div>
                </div>
                <div className='clearfix' />
              </li>
              <li className='divider' />
              <li><Link to='/settings/accounts'>Account Settings</Link></li>
              <li className='divider' />
              <li>
                <Link to='#' onClick={this._logout}><i className='fa fa-sign-out' />Logout</Link>
              </li>
            </ul>
          </li>
        </ul>
        <ul className='nav nav-outlet-dekstop navbar-nav mk-navbar-nav uppercase visible-md visible-lg'>
          {subMenuOf['dashboard'] && this._getNav('dashboard')}
          {subMenuOf['reports'] && this._getNav('reports')}
          {subMenuOf['library'] && this._getNav('library')}
          {subMenuOf['ingredient'] && this._getNav('ingredient')}
          {subMenuOf['inventory'] && this._getNav('inventory')}
          {subMenuOf['customers'] && this._getNav('customers')}
          {subMenuOf['employees'] && this._getNav('employees')}
          {subMenuOf['outlets'] && this._getNav('outlets')}
        </ul>
        <ul className='nav navbar-nav mk-navbar-nav uppercase visible-xs visible-sm text-center full-width'>
          {subMenuOf['dashboard'] && this._getNavMobileView('dashboard')}
          {subMenuOf['reports'] && this._getNavMobileView('reports')}
          {subMenuOf['account settings'] && this._getNavMobileView('account settings')}
          <li>
            <Link to='#' onClick={this._logout}><i className='fa fa-sign-out' />
                Logout
            </Link>
          </li>
        </ul>
      </div>
    )
  }

  _getNav = (name) => {
    let {location, subMenuOf} = this.props
    const path = location.pathname
    const firstSubNav = this._getFirstSubNav(subMenuOf[name])
    let newLabel = false
    if (firstSubNav.startsWith('/employees') && shouldShowEmployeeManagement()) {
      newLabel = true
    } else if (firstSubNav.startsWith('/library') && shouldShowSalesTypeLibrary()) {
      newLabel = true
    } else if (firstSubNav.startsWith('/library') && shouldShowPromoLibrary()) {
      newLabel = true
    }
    return (
      <li>
        <Link
          className={path.startsWith(`/${name}`) || path === '/' ? 'active' : ''}
          to={firstSubNav}
        >
          {name} {newLabel && <span className='new-label'>NEW</span> }
        </Link>
      </li>
    )
  }

  _getNavMobileView = (name) => {
    let {location, subMenuOf} = this.props
    const path = location.pathname
    return (
      <li>
        <Link
          className={path.startsWith(`/${name}`) || path === '/' ? 'active' : ''}
          to={this._getFirstSubNav(subMenuOf[name])}
          data-toggle='collapse'
          data-target='.navbar-collapse'
        >
          {name}
        </Link>
      </li>
    )
  }

  _getFirstSubNav = (permissions) => {
    return _.orderBy(permissions, 'priority_rank')[0].urls[0]
  }

  _logout = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.props.dispatch(logout())
  }
}

export default NavLoggedIn



// WEBPACK FOOTER //
// ./app/components/Nav/NavLoggedIn/NavLoggedIn.js